var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.container},[_c('div',[_vm._v(_vm._s(_vm.getDateField(_vm.data.date))+" / "+_vm._s(_vm.data.caption))]),_c('img',{class:_vm.$style.screen,attrs:{"src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }